package club.srams.website.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initRockhoundCodeEthicsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("RockhoundCodeEthics.md", FrontMatterElement.Builder { addScalar("title", "Rockhound Code of Ethics"); }))
}

@Page("/rockhound-code-ethics")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun RockhoundCodeEthicsPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("rockhound-code-of-ethics") }) {
        org.jetbrains.compose.web.dom.Text("Rockhound Code of Ethics")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will respect both private and public property and will do no collecting on privately owned land without permission from the owner.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will keep informed on all laws, regulations and rules governing collecting on private lands and will observe them.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will to the best of my ability, ascertain the boundary lines of property on which I plan to collect.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will use no firearms or blasting materials in collecting areas.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will cause no willful damage to property of any kind, such as fences, signs, buildings, etc.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will leave all gates as found.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will build fires only in designated or safe places and will be certain they are completely extinguished before leaving the area.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will discard no burning materials – matches, cigarettes, etc.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will fill all excavation holes which may be dangerous to livestock.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will not contaminate wells, creeks, or other water supplies.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will cause no damage to collecting material and will take home only what I can reasonably use.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will support the Rockhound Project H.E.L.P. (Help Eliminate Litter Please) and will leave all collecting areas devoid of litter, regardless of how found.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will cooperate with Field Trip Leaders and those in designated authority in all collecting areas.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will report to my Club or Federation Officers, Bureau of Land Management, or other proper authorities, any deposit of petrified wood or other material on public lands which should be protected for the enjoyment of future generations and for public educational and scientific purposes.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will appreciate and protect our heritage of Natural Resources.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("I will observe the “Golden Rule”, will use Good Outdoor Manners and will at all times conduct myself in a manner which will add to the stature and Public Image of Rockhounds everywhere.")
        }
    }
}
